import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '../../shared/Icon';
interface IProps {
  message: string;
  color?: string;
}

export const DataWarning = (props: IProps): React.ReactElement => {
  return (
    <DataWarningContainer style={{}}>
      <Icon
        name='report'
        title={props.message}
        color={props.color ?? 'var(--color-secondary-text)'}
      />
    </DataWarningContainer>
  );
};

const DataWarningContainer = styled.div`
  position: absolute;
  right: 5px;
  cursor: pointer;
`;
